import { render } from "./AssetExplorer.vue?vue&type=template&id=0ecc840c&scoped=true"
import script from "./AssetExplorer.vue?vue&type=script&lang=js"
export * from "./AssetExplorer.vue?vue&type=script&lang=js"

import "./AssetExplorer.vue?vue&type=style&index=0&id=0ecc840c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecc840c"]])

export default __exports__